export const SET_SELECTED_SORT = 'SET_SELECTED_SORT';
export const UPDATE_FILTERED_MODEL_JOBS = 'UPDATE_FILTERED_MODEL_JOBS';

export const setSelectedSort = (sortKey) => (dispatch) => {
  const mapSortKeyToColumnAndOrder = (sortKey) => {
    
    if (!sortKey || sortKey == 'None') {
      return { name: '', code: 'id', order: 'ASC' };
    }

    const [column, order] = sortKey.split(' (').slice(0, 2);
    let columnName;

    switch (column) {
      case 'Job Title':
        columnName = 'org_job_title';
        break;
      case 'Job Code':
        columnName = 'org_job_code';
        break;
      case 'Job Code Key':
        columnName = 'org_job_code_key';
        break;
      case 'Job Family':
        columnName = 'job_family';
        break;
      default:
        columnName = '';
    }

    return {
      name: sortKey,
      sortColumn: columnName,
      sortOrder: order === 'ASC)' ? 'ASC' : 'DESC',
    };
  };

  const { name, sortColumn, sortOrder } = mapSortKeyToColumnAndOrder(sortKey);

  dispatch({
    type: SET_SELECTED_SORT,
    payload: { name, sortColumn, sortOrder },
  });
};

export const updateFilteredModelJobs = (jobs) => ({
  type: UPDATE_FILTERED_MODEL_JOBS,
  payload: jobs
});
